import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { defaultLang } from "./config-lang";
import translationEn from "./langs/en.json";
import translationTr from "./langs/tr.json";
// ----------------------------------------------------------------------

const lng = localStorage.getItem("lang") || defaultLang?.value;

i18n.use(initReactI18next).init({
  resources: {
    en: { translations: translationEn },
    tr: { translations: translationTr },
  },
  lng,
  fallbackLng: "en",
  debug: false,
  ns: ["translations"],
  defaultNS: "translations",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
